import type { Option } from '@/components/ui/select'
import { DeliverableSetStatus } from '@/schema'

/**
 * Constants for Deliverable Set feature
 */

export const DELIVERABLE_SET_STATUSES = {
  [DeliverableSetStatus.DRAFT]: 'Draft',
  [DeliverableSetStatus.IN_REVIEW]: 'In Review',
  [DeliverableSetStatus.APPROVED]: 'Approved',
  [DeliverableSetStatus.ARCHIVED]: 'Archived',
}

export const getStatusFilterLabel = (status: DeliverableSetStatus): string => {
  return DELIVERABLE_SET_STATUSES[status] || status
}

export const formatStatusFilterOptions = (): Option[] => {
  return Object.entries(DELIVERABLE_SET_STATUSES).map(([value, label]) => ({
    value,
    label,
  }))
}

// Query Keys
export const QUERY_KEY_DELIVERABLE_SET_LIST = 'deliverable-set-list'
export const QUERY_KEY_DELIVERABLE_SET_DETAIL = 'deliverable-set-detail'

export const DELIVERABLE_SET_LIST_QUERY_KEY = (params: (string | number)[]) =>
  [QUERY_KEY_DELIVERABLE_SET_LIST, ...(params ? [params] : [])] as const

export const DELIVERABLE_SET_DETAIL_QUERY_KEY = (id: string | number) =>
  [QUERY_KEY_DELIVERABLE_SET_DETAIL, id] as const

// Stale Time
export const DELIVERABLE_SET_DETAIL_STALE_TIME = 5 * 60 * 1000
